module.exports = __webpack_public_path__ + "ProjectWechatQRCode.png?6cf58db59ade540bdb9de0c1cbb9cb1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/LCStudies/ProjectWechatQRCode.png
// module id = 193
// module chunks = 0